module.exports = __webpack_public_path__ + "static/media/klitchko.b3c3ccf6.wav";